var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.handleSearch()}}},[_c('v-icon',[_vm._v("mdi-magnify")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }